const WebSessionTrackingKeys = {
	WEB_SESSION_START: "Web Session Start",
	WEB_SESSION_END: "Web Session End",
};
export default WebSessionTrackingKeys;
